export default __webpack_public_path__ + "static/media/Youssef Darwish.9184a4f1.jpeg";